export const TAGGING_CONSTS = {
  moduleName: 'epb-tagging',

  getters: {
    data: 'data',
  },

  actions: {
    tagView: 'tagView',
    tagAction: 'tagAction',
    loadViews: 'loadViews',
    loadActions: 'loadActions',

    submitFeedback: 'submitFeedback',
  },

  mutations: {
    setData: 'setData',
  },
}
